// src/pages/ComoEncargar.jsx
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../como-encargar.css";

const ComoEncargar = () => {
  return (
    <>
      <Navbar />

      <div className="encargo-container">
        <div className="encargo-card">
          <h2>¿CÓMO HACER UN ENCARGO?</h2>

          <p className="encargo-lead">
            En Lifting Store la mayoría de productos se trabajan por <b>encargo</b> (sin stock fijo).
            Para encargar un producto se abona un <b>anticipo mínimo del 20%</b> del total.
          </p>

          <div className="encargo-grid">
            <div className="encargo-step">
              <div className="encargo-step__num">1</div>
              <div className="encargo-step__content">
                <h3>Elegí tu producto</h3>
                <p>
                  Escribinos por WhatsApp para comentarnos qué producto te gustaria encargar.
                </p>
              </div>
            </div>

            <div className="encargo-step">
              <div className="encargo-step__num">2</div>
              <div className="encargo-step__content">
                <h3>Confirmamos disponibilidad</h3>
                <p>
                  Verificamos stock con el proveedor y te confirmamos la fecha estimada de llegada.
                </p>
              </div>
            </div>

            <div className="encargo-step">
              <div className="encargo-step__num">3</div>
              <div className="encargo-step__content">
                <h3>Encargás con el 20%</h3>
                <p>
                  Abonás un mínimo del 20% para encargar tu pedido. El resto se paga cuando el producto llega a Argentina
                  (o antes si se prefiere).
                </p>
              </div>
            </div>

            <div className="encargo-step">
              <div className="encargo-step__num">4</div>
              <div className="encargo-step__content">
                <h3>Importación y seguimiento</h3>
                <p>
                  Gestionamos la compra y el proceso logístico. Te mantenemos al tanto con actualizaciones cuando corresponda.
                </p>
              </div>
            </div>

            <div className="encargo-step">
              <div className="encargo-step__num">5</div>
              <div className="encargo-step__content">
                <h3>Pago del saldo</h3>
                <p>
                  Cuando llega tu producto, abonás el saldo restante y coordinamos envío o retiro.
                </p>
              </div>
            </div>

            <div className="encargo-step">
              <div className="encargo-step__num">6</div>
              <div className="encargo-step__content">
                <h3>Entrega</h3>
                <p>
                  Enviamos por Correo Argentino (o coordinamos retiro). Te pasamos el comprobante / seguimiento si aplica.
                </p>
              </div>
            </div>
          </div>

          <div className="encargo-divider" />

          <section className="encargo-section">
            <h3>Medios de pago</h3>
            <p>
              Aceptamos transferencia o efectivo en USD, USDT o pesos (cotización dólar blue del momento
              de la transferencia).
            </p>
          </section>

          <section className="encargo-section">
            <h3>Tiempos estimados</h3>
            <p>
              Los tiempos de llegada son <b>estimados</b> y pueden variar por logística internacional, aduana o disponibilidad del proveedor.
              Siempre te vamos a avisar cualquier novedad relevante.
            </p>
          </section>

          <section className="encargo-section">
            <h3>Cancelaciones y devoluciones en encargos</h3>
            <ul className="encargo-list">
              <li>
                Una vez confirmado el encargo con el proveedor, el anticipo no es reembolsable.
              </li>
              <li>
                Los productos por encargo no tienen cambio ni devolución, sin excepción (talles/variantes elegidos por el cliente).
              </li>
              <li>
                Si el proveedor no pudiera cumplir el pedido por falta de stock, se reintegra el anticipo.
              </li>
            </ul>
            <p className="encargo-note">
              Tip: si tenés dudas de talle, escribinos antes de encargar y te ayudamos a elegir.
            </p>
          </section>

          <section className="encargo-section">
            <h3>¿Querés encargar ahora?</h3>
            <p>
              Escribinos por redes y te armamos el pedido con disponibilidad, precio final y anticipo.
            </p>

            <div className="encargo-actions">
              <a className="encargo-btn" href="https://wa.me/5491128181122" target="_blank" rel="noreferrer">
                Hablar por WhatsApp
              </a>
              <a className="encargo-btn encargo-btn--ghost" href="mailto:liftingstore.ar@gmail.com">
                Enviar mail
              </a>
            </div>

            <p className="encargo-foot">        
              Horario de soporte: <b>Lun a Sáb 9 a 21</b> · <b>Dom y feriados 11 a 18</b>.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ComoEncargar;
